import FormFieldHelp from '../../ReusableComponents/FormFieldHelp';
import React from 'react';
import { Form } from 'react-bootstrap';
import { useOrganizationBranding } from '../../MinhaOrganizadora/hooks';
export default function PortalSelectiveToggle({ value, onChange, companyEnabled, helpAsTooltip = false }) {
  const branding = useOrganizationBranding();
  if (!(companyEnabled ?? branding.data?.portal_enabled)) return null;
  return (
    <div className="mb-4 hidethis">
      <Form.Check
        id="selection-portal-enabled"
        type="switch"
        label={<>{
          branding.data?.change_text
            ? 'Habilitar inscrições neste processo seletivo'
            : 'Habilitar inscrições nesta instituição'
        }{helpAsTooltip && <FormFieldHelp>Configure os cargos, o formulário e as publicações no módulo de Inscrições.</FormFieldHelp>}</>}
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
      />
      {!helpAsTooltip && <p className="text-muted mt-2 mb-0" style={{ fontSize: 14 }}>
        Configure os cargos, o formulário e as publicações no módulo de Inscrições.
      </p>}
    </div>
  );
}
